export const AppsflyerEvent = {
    finance_topup_view: 'finance_topup_view',
    finance_topup_sum_click: 'finance_topup_sum_click',
    finance_topup_sum_change: 'finance_topup_sum_change',
    finance_topup_sum_error: 'finance_topup_sum_error',
    finance_topup_tag_sum_click: 'finance_topup_tag_sum_click',
    finance_topup_method_click: 'finance_topup_method_click',
    finance_topup_method_changed_click: 'finance_topup_method_changed_click',
    finance_topup_done_click: 'finance_topup_done_click',
    finance_topup_done_redirect: 'finance_topup_done_redirect',
    finance_topup_success_view: 'finance_topup_success_view',
    finance_topup_failed_view: 'finance_topup_failed_view',
    finance_topup_failed_method_click: 'finance_topup_failed_method_click',

    topup_onboarding_sum_view: 'topup_onboarding_sum_view',
    topup_onboarding_sum_click: 'topup_onboarding_sum_click',
    topup_onboarding_method_view: 'topup_onboarding_method_view',
    topup_onboarding_method_click: 'topup_onboarding_method_click',

    finance_topup_csat_view: 'finance_topup_csat_view',
    finance_topup_csat_click: 'finance_topup_csat_click',
} as const

export type TAppsflyerEvent = (typeof AppsflyerEvent)[keyof typeof AppsflyerEvent]
